import React from 'react'
import { Route } from 'react-router-dom'
import LxScrollTop from '@/components/LxScrollTop/index'
// import LxHeader from './components/LxHeader/One'
import Home from '@/pages/Home'
import LxFooter from './components/LxFooter'
import SocialRecruitment from '@/pages/SocialRecruitment'
import CampusRecruitment from '@/pages/CampusRecruitment'
import Detail from '@/pages/Detail'
import LxTransition from '@/components/LxTransition'
import PositionList from '@/pages/PositionList'
import ProblemCenter from '@/pages/ProblemCenter'
import RecruitmentNews from '@/pages/RecruitmentNews'
import RecruitmentNewsDetail from '@/pages/RecruitmentNewsDetail'
import Social from '@/pages/Mobile/Social'
import MobileHome from '@/pages/Mobile/Home'
import Campus from '@/pages/Mobile/Campus'
import Brand from '@/pages/Mobile/Brand'
// import Router from '@/router'

function App() {
  let homeFlag = Home;
  if (window.location.pathname === '/') {
    // 如果终端为移动端，则跳转至移动端首页
    const UA = window.navigator.userAgent.toLowerCase();
    const isAndroid = UA && UA.indexOf('android') > 0;
    const isIos = UA && /(iphone|ipad|ipod|ios)/i.test(UA);
    if (isAndroid || isIos) homeFlag = MobileHome;
  }

  return (
    <LxScrollTop>
      {/* <LxHeader></LxHeader> */}
      <LxTransition>
        {/* <Router /> */}
        <Route path='/positionList' component={PositionList}/>
        <Route path='/QA' component={ProblemCenter}/>
        <Route path='/socialRecruitment' component={SocialRecruitment}/>
        <Route path='/campusRecruitment' component={CampusRecruitment}/>
        <Route path='/detail' component={Detail}/>
        <Route path='/recruitmentNews' component={RecruitmentNews}/>
        <Route path='/recruitmentNewsDetail' component={RecruitmentNewsDetail}/>
        <Route path='/mobile/social' component={Social}/>
        <Route path='/mobile/home' component={MobileHome}/>
        <Route path='/mobile/campus' component={Campus}/>
        <Route path='/mobile/brand' component={Brand}/>
        <Route path='/' component={Home}/>
      </LxTransition>
      <LxFooter></LxFooter>
    </LxScrollTop>
  );
}

export default App;